module.exports = __webpack_public_path__ + "img/playbutton16.b07f937f.png";